<template>
  <h1 >Processing Logs Details</h1>
  <div id="page-rfid-dashboard" class="content-section">
    <div class="page-section">

      <div class="row">
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Go Back"
                  input-class="$reset btn-rfid-xsm btn btn-rfid btn-associate btn-goback"
                  @click="goTo('Dashboard')"
                  prefix-icon="arrowLeft"
                  prefix-icon-class="btn-rfid-back"
              />
            </div>
          </div>
        </div>


      <div class="clearfix"></div>

      <div class="content-section">
        <div class="mb-4">
          <label class="formkit-label">Current batch selected:</label>
          {{currentBatchId}} ({{formatLondon(currentBatchId)}})
        </div>
        <div>
          <easy-data-table
              v-model:server-options="serverOptions"
              :server-items-length="serverItemsLength"
              :headers="headers"
              :items="associationLogs"
              :search-field="searchField"
              :search-value="searchValue"
              :loading="loading"
              alternating
              border-cell
              buttons-pagination
              multi-sort
          >
            <template #empty-message>
              nothing here for the moment
            </template>

            <template #item-created_at="item">
              <div >{{formatLondon(item.created_at)}}</div>
            </template>
            <template #item-customer_name="item">
              <router-link target="_blank" :to="{ name: 'ViewCustomer', params: { id: item.customer.customer_id } }">
                <div >{{ item.customer.first_name }} {{ item.customer.last_name }}</div>
              </router-link>
            </template>

            <template #item-garment_type="item">
              <router-link target="_blank" :to="{ name: 'GarmentTypeEdit', params: { id: item.garmenttype.garmenttype_id } }">
                <div >{{ item.garmenttype.garment_type }}</div>
              </router-link>
            </template>

            <template #item-service_type="item">
              <div v-if="item.servicetype" >{{ item.servicetype.servicetype }}</div>
            </template>
            <template #item-user="item">
              <div >{{ item.user.username}}</div>
            </template>

            <template #loading>
              <font-awesome-icon
                  icon="spinner"
                  size="2x"
                  title="Loading"
                  spin
              >
              </font-awesome-icon>
            </template>
          </easy-data-table>
        </div>
      </div>

    </div>
  </div>


</template>


<script setup>

import {onMounted, ref, inject, reactive, watch} from 'vue'
import { useRouter } from 'vue-router'
import 'bootstrap/dist/css/bootstrap.min.css';
import RFIDService from "@/services/RFIDService";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import { formatLondon } from '@/utils/dateUtils';

const router = useRouter();

const currentBatchId = parseInt(router.currentRoute.value.params.id);

const associationLogs =  ref([]);
const headers = [
  { text: "Created At", value: "created_at", sortable: true  },
  { text: "Tag Value", value: "rfid_value", sortable: true },
  { text: "Account Name", value: "customer_name", sortable: true },
  { text: "Garment Name", value: "garment_type", sortable: true },
  { text: "Service Name", value: "service_type", sortable: true },
  { text: "User", value: "user", sortable: true },
];
const searchField = ref("batch_id");
const searchValue = ref("");

const nowDate = new Date();
const currentDate = new Date(Date.UTC(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate()));
const defaultStartDate = new Date(new Date().setDate(currentDate.getDate() - 7));

const selectedStartDate = ref(defaultStartDate);
const selectedEndDate = ref(currentDate);
const datepickerClearedKey = ref(0);

const forceRenderDatepicker = () => {
  datepickerClearedKey.value += 1;
};

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
  page: 1,
  rowsPerPage: 25,
  //sortBy: ["logged_at"],
  sortType: ["desc"],
  exportFormat: "none",
  start_date: defaultStartDate,
  end_date: currentDate,
  search: "",
});

watch(() => serverOptions.value.page, () => {
  console.log("Page changed to: ", serverOptions.value.page);
  serverOptions.value.page = parseInt(serverOptions.value.page);
  loadRFIDassociationLogs();
});
watch(() => serverOptions.value.rowsPerPage, () => {
  console.log("rowsPerPage changed to: ", serverOptions.value.rowsPerPage);
  serverOptions.value.rowsPerPage = parseInt(serverOptions.value.rowsPerPage);
  loadRFIDassociationLogs();
});


const  createDateAsUTC = (date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
}

const goTo = (pageSection) =>   {
  switch (pageSection) {
    case "Dashboard":
      window.open(
          "/rfid/association-logs",
          "_self"
      );
      break;
  }
}
const loadRFIDassociationLogs = async () => {

  console.log('get logs');
  const dateoptions = { year: 'numeric', month: 'numeric', day: 'numeric' }
  serverOptions.value.start_date = new Date(serverOptions.value.start_date).toLocaleDateString('fr-CA', dateoptions);
  serverOptions.value.end_date = new Date(serverOptions.value.end_date).toLocaleDateString('fr-CA', dateoptions);

  console.log(serverOptions.value);
  loading.value = true;
  const {
    serverCurrentPageItems,
    serverTotalItemsLength,
  } = await RFIDService.searchRFIDAssociationLogs(router.currentRoute.value.params.id, serverOptions.value);
  associationLogs.value = serverCurrentPageItems;
  serverItemsLength.value = serverTotalItemsLength;
  loading.value = false;
}
onMounted(async () => {
 loadRFIDassociationLogs();
});

</script>


<style scoped>
.main-section > h1:first-child {
  background: var(--associate-tag-bg-color);
}
.error-message {
  color: var(--red-color);
  font-weight: bold;
}
</style>
